import { lazy } from 'react';

export const PartnerBirthDatePageLazy = lazy(() => import('./partner-birthdate'));
